import urljoin from 'url-join';
import { api } from '@/shared/services/baseApiClient';
import { config } from '@/config/config';
import { UninstallAppRequest } from '../../shared/models/uninstallAppRequest';
import { IAppApiUninstall } from '../../shared/services/appApiFactory';
import {
  GetWhatsAppAccountRequest,
  GetWhatsAppInstalledAppResponse,
  GetWhatsAppSubscriptionRequest,
  InstallWhatsAppRequest,
  WhatsAppAccount,
  WhatsAppInstalledApp,
  WhatsAppSubscription,
} from '../models';

export interface WhatsAppApi {
  install(request: InstallWhatsAppRequest): Promise<void>;
  uninstall(workspaceId: string, installId: string): Promise<void>;
  getInstalledApp(workspaceId: string): Promise<GetWhatsAppInstalledAppResponse>;
  getAccount(workspaceId: string, accountId: string, apiKey: string): Promise<WhatsAppAccount>;
  getSubscription(workspaceId: string, appId: string, appSecret: string): Promise<WhatsAppSubscription>;
}

class WhatsAppApiService implements IAppApiUninstall, WhatsAppApi {
  private version = 'v1';

  public install(request: InstallWhatsAppRequest): Promise<void> {
    return api.send('POST', urljoin(config().messengerHost, this.version, 'app', 'install', 'whatsapp'), request);
  }

  public uninstall(workspaceId: string, installId: string): Promise<void> {
    const request: UninstallAppRequest = {
      workspaceId,
      installId,
    };

    return api.send('POST', urljoin(config().messengerHost, this.version, 'app', 'uninstall', 'whatsapp'), request);
  }

  public getInstalledApp(workspaceId: string): Promise<GetWhatsAppInstalledAppResponse> {
    return api.send<GetWhatsAppInstalledAppResponse>(
      'GET',
      urljoin(config().messengerHost, this.version, `app?workspaceid=${workspaceId}&type=whatsapp`),
    );
  }

  public getAccount(workspaceId: string, accountId: string, apiKey: string): Promise<WhatsAppAccount> {
    const request: GetWhatsAppAccountRequest = {
      workspaceId,
      accountId,
      apiKey,
    };

    return api.send<WhatsAppAccount>(
      'POST',
      urljoin(config().messengerHost, this.version, `app`, `whatsapp`, `account`),
      request,
    );
  }

  public getSubscription(workspaceId: string, appId: string, appSecret: string): Promise<WhatsAppSubscription> {
    const request: GetWhatsAppSubscriptionRequest = {
      workspaceId,
      appId,
      appSecret,
    };

    return api.send<WhatsAppSubscription>(
      'POST',
      urljoin(config().messengerHost, this.version, `app`, `whatsapp`, `subscription`),
      request,
    );
  }

  public canUninstall(): boolean {
    return true;
  }

  public getUninstallNotAllowedMessage(): string {
    return '';
  }
}

export const whatsAppApi = new WhatsAppApiService();
